import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import jwtDecode from "jwt-decode";
import moment from "moment";
import {routePath} from "../../router/paths";
import {Button, Input, message, Tooltip} from "antd";
import { Select } from 'antd';
import {SaveOutlined} from "@ant-design/icons";
import {startRegistrationProcess} from "../../store/notary-registration/actions";
import CheckDsModal from "./Components/CheckDsModal/CheckDsModal";

import {BARS_DOWNLOAD_URLS} from "../../utils/constants";
import {BigLoading} from "../../components/BigLoading";
import {notaryRequestTypeVocabulary, translate} from "../../utils/utils";

const Verification = (props) => {
  const dispatch = useDispatch();
  const TOKEN = localStorage.getItem("token");
  const info = jwtDecode(JSON.parse(TOKEN).access_token);
  const selectOptions = [
    {
      value: BARS_DOWNLOAD_URLS.win64,
      label: 'BarsCryptor.Cloud для Windows x64',
    },
    // {
    //   value: BARS_DOWNLOAD_URLS.win32,
    //   label: 'BarsCryptor.Cloud для Windows x32',
    // },
    {
      value: BARS_DOWNLOAD_URLS.mac64,
      label: 'BarsCryptor.Cloud для Mac',
    },
    {
      value: BARS_DOWNLOAD_URLS.linuxDeb,
      label: 'BarsCryptor.Cloud для Linux (deb)',
    },
    {
      value: BARS_DOWNLOAD_URLS.linuxRpm,
      label: 'BarsCryptor.Cloud для Linux (rpm)',
    },
  ];
  const [isNotary, setIsNotary] = useState(false);
  const [kepIsValid, setKepIsValid]= useState(null);
  const [regFromVisible,setRegFormVisible] = useState(false);
  const [selectedVersion, setSelectedVersion] = useState(selectOptions[0].value);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [primaryMessageVisibility, setPrimaryMessageVisibility] = useState(false);
  const [kepId, setKepId] = useState(null);
  const [notaryId, setNotaryId] = useState(null);
  const startRegistrationState = useSelector((state) => state.notaryRegistration.startRegistration);


  useEffect(() => {

    if (info) {
      console.log("INFO", info)
      // !info?.data?.idm?.isNotary && console.log("info?.data?.idm?.isNotary", info?.data?.idm?.isNotary)
      info?.data?.idm?.isNotary && setIsNotary(true);
      console.log("date", moment().parseZone().format("YYYY-MM-DD"));
      const currentDate = moment().parseZone().format("YYYY-MM-DD");
      const kepExpiresDate = moment(info?.data?.idm?.notaryExpirationDate).parseZone().format("YYYY-MM-DD");
      info?.data?.idm?.notaryNumber && setNotaryId(info?.data?.idm?.notaryNumber)
      console.log("kepExp", kepExpiresDate)
      const dateCompare = moment(currentDate).isBefore(kepExpiresDate)
      console.log("dateCompare", dateCompare)
      // info?.data?.idm?.kepExpires
      if (info?.data?.idm?.isNotary) {
        setIsNotary(true)
        if (dateCompare) {
        // if (false) {
          console.log("Check and redirect", dateCompare)
          props.history.push({
            pathname: routePath.NEW_REQUEST,
            state: {backPath: props.history.location.pathname}
          })
        } else {
          setKepIsValid(false)
          setPrimaryMessageVisibility(true)
        }
      } else {
        setPrimaryMessageVisibility(true)
      }
    }
  }, [])

  useEffect(()=>{
    if(startRegistrationState?.payload?.data || startRegistrationState?.error){
      setIsModalOpen(true)

    }

  },[startRegistrationState])

  const handleSelect = (value) => {
    console.log(`selected ${value}`);
    setSelectedVersion(value);
  };

  const handleKepChange = e =>{
    const {value} = e.currentTarget;
    setKepId(value);
  };



  message.config({
    top: "10%",
    duration: 2,
  });

  return (
    <div className="form-container">
      {console.log("isNotary",isNotary)}
      {!info?.data?.idm?.isNotary && primaryMessageVisibility &&
        <div style={{
          marginTop:"10%",
          width: "30%",
          // display: "flex"
        }}>
        <h2 style={{paddingLeft:"2rem"}}>У Вас відсутня ознака приналежності до нотаріусів!</h2>
        <div style={{
          display:"flex",
          // justifyContent:"space-evenly"
        }}>
          <Tooltip title="Пройти реєстрацію для отримання ознаки приналежності до нотаріусів за допомогою КЕП">
            <Button  className="datas-btn datas-btn-small datas-btn-green"
                     style={{marginRight:"2rem"}}
                     htmlType="submit"
                     onClick={() => {
                       setRegFormVisible(true)
                       setPrimaryMessageVisibility(false)
                     }}>Пройти реєстрацію</Button>
          </Tooltip>
          <Tooltip title="Повернутись до сторінки вибору кабінету">
          <Button
            className="datas-btn datas-btn-small datas-btn-red"
            style={{marginRight: "2rem"}}
            onClick={() => props.history.push({
              pathname: routePath.DIGITAL_FRONT,
              state: {backPath: props.history.location.pathname}
            })}
          >Повернутись на головну</Button>
          </Tooltip>
        </div>
      </div>
      }

      {info?.data?.idm?.isNotary && !kepIsValid && !regFromVisible &&
        <div style={{marginTop:"10%"}}>
          <h2 style={{marginBottom:"0.5rem"}}>Строк дії вашого КЕП сплив. Просимо пройти повторну ідентифікацію у разі, якщо строк дії КЕП було продовжено</h2>
          {!regFromVisible && !kepIsValid &&
            <div style={{
              display:"flex",
              justifyContent:"space-evenly"
            }}>
              <Button
                className="datas-btn datas-btn-small datas-btn-green"
                htmlType="submit"
                onClick={() => {
                  setRegFormVisible(true)
                  setPrimaryMessageVisibility(false)
                }}
              >
                "Пройти реєстрацію"
              </Button>
              <Button
                className="datas-btn datas-btn-small datas-btn-red"
                style={{marginRight: "2rem"}}
                onClick={() => props.history.push({
                  pathname: routePath.REQUEST_LIST,
                  state: {backPath: props.history.location.pathname}
                })}
              >
                Відмовитись
              </Button>
            </div>}
        </div>
      }

      {regFromVisible &&
        <div style={{marginTop: "5%"}}>
        <div style={{fontWeight:400, fontSize:"1rem", paddingBottom:"0.5rem"}}>Для роботи з Порталом і можливості підпису документів КЕП Вам необхідно встановити ПЗ BarsCryptor Cloud
          Client на комп’ютер
        </div>
        <div style={{display: "flex", marginBottom:"1rem"}}>
          <Select
            defaultValue={selectOptions[0]}
            style={{width: "30%"}}
            onChange={handleSelect}
            options={selectOptions}
          />
          <Tooltip title="Завантажити файл" placement="right" color="#DCE123">
            <div
              className='download-button'
              style={{marginLeft:0}}
              onClick={() => {
                message.info("Направлено запит на завантаження")
              }
              }
            >
              <a href={selectedVersion}
                 className="bars_link">
                <SaveOutlined  style={{fontSize: "1rem", color:"#262626"}}/>
              </a>

            </div>
            {/*<div className='download-button'*/}
            {/*     onClick={() => console.log("123")}>*/}
            {/*  <SaveOutlined style={{fontSize: "1rem"}}/>*/}
            {/*</div>*/}
          </Tooltip>
        </div>


        <div style={{marginBottom:"1rem"}}>
          <a target="_blank"
             href={BARS_DOWNLOAD_URLS.instructions}
          >
          <span style={{fontSize:"1rem"}}>Інструкція до ПЗ BarsCryptor Cloud Client</span></a>
        </div>

          <div className="container">
            <form>
                <h2 style={{fontWeight:400, fontSize:"1rem"}}>Підтвердження реєстрації для отримання ознаки приналежності до нотаріусів за допомогою КЕП.</h2>
              <h2 style={{fontWeight:400, fontSize:"1rem", paddingBottom:"0.5rem"}}>Введіть в поле нижче ідентифікатор згенерований з ПЗ BarsCryptor Cloud Client</h2>
                    <Input
                      type="text"
                      allowClear
                      placeholder='Введіть ідентифікатор користувача'
                      name="identity"
                      onChange={handleKepChange}
                    />
                <div className="button_center">
                  <Button
                    style={{color: "#000000", marginTop:"8px", marginBottom:"8px"}}
                    // disabled={!kepId || signing.isFetching}
                    onClick={()=> {
                      console.log("sign")
                      dispatch(startRegistrationProcess(kepId))
                      // setIsModalOpen(true)
                    }}
                    key="submit"
                    type="primary"
                  >Продовжити</Button>
                </div>
              {/*{signing && signing.isFetching &&*/}
              {/*  <div style={{fontSize: "16px" }}>*/}
              {/*    Відбувається процес підписання <Spin style={{marginLeft: "4px"}} indicator={Loading} />*/}
              {/*  </div>}*/}
            </form>
          </div>

            {startRegistrationState.isFetching && <BigLoading/>}


      </div>}

      {/*<button onClick={()=>setIsModalOpen(true)}>modal</button>*/}
      <CheckDsModal
        visible={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        setRegFormVisible={setRegFormVisible}
        setPrimaryMessageVisibility={setPrimaryMessageVisibility}
        history={props.history}
      />

    </div>
  );
};

export default Verification;